import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createTaxZone } from "../../api/apiTax";
import parseError from "../../utils/parseError";

export const useCreateTaxZone = () => {
    const queryClient = useQueryClient();

    const { mutate: createTaxZoneMutate, isPending: isCreating } = useMutation({
        mutationFn: createTaxZone,
        onSuccess: (res) => {
            toast.success(res.message || "Tax zone created successfully");
            queryClient.invalidateQueries(["tax-zones"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to create tax zone");
        },
    });

    return { createTaxZoneMutate, isCreating };
};
